module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "attention-car.b5058860.png" + "?" + Date.now();